import { FC } from "react";
import { MeetingPermissionsModalContent } from "@/components/desktop/system-permissions/meetings/meetings-permissions-modal-content";
import { RecallPermissionKind } from "@/modules/electron/types";
import { useSystemPermissionHandlers } from "@/components/desktop/system-permissions/shared";
import { PermissionStatusMap } from "@/components/desktop/system-permissions/shared/system-permissions.types";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onRestart: () => void;
  permissionStatusMap: PermissionStatusMap;
  advancedMeetingPermissionsRequired: boolean;
  onRequestPermission: (permission: RecallPermissionKind) => Promise<void>;
  onOpenPermissionPane: (permission: RecallPermissionKind) => Promise<void>;
  isDetectionOfUnscheduledMeetingsEnabled: boolean;
  onChangeDetectionOfUnscheduledMeetings: (checked: boolean) => void;
  isRemindMeToJoinMeetingsAndTakeNotesEnabled: boolean;
  onChangeRemindMeToJoinMeetingsAndTakeNotes: (checked: boolean) => void;
  platform: {
    isMacOs?: boolean;
    isIntelMacDesktop?: boolean;
  };
};

export const MeetingPermissionsModal: FC<Props> = ({
  isOpen,
  onClose,
  permissionStatusMap,
  advancedMeetingPermissionsRequired,
  onRestart,
  onRequestPermission,
  onOpenPermissionPane,
  isDetectionOfUnscheduledMeetingsEnabled,
  onChangeDetectionOfUnscheduledMeetings,
  isRemindMeToJoinMeetingsAndTakeNotesEnabled,
  onChangeRemindMeToJoinMeetingsAndTakeNotes,
  platform,
}: Props) => {
  const {
    resolveConfigurationStatus,
    handleEnablePermission,
    handleOpenPermissionPane,
    restartRequired,
  } = useSystemPermissionHandlers({
    onRequestPermission,
    onOpenPermissionPane,
    permissionStatusMap,
  });

  return (
    <MeetingPermissionsModalContent
      platform={platform}
      isOpen={isOpen}
      onClose={onClose}
      resolveConfigurationStatus={resolveConfigurationStatus}
      handleEnablePermission={handleEnablePermission}
      handleOpenPermissionPane={handleOpenPermissionPane}
      restartRequired={restartRequired}
      onRestart={onRestart}
      advancedMeetingPermissionsRequired={advancedMeetingPermissionsRequired}
      isDetectionOfUnscheduledMeetingsEnabled={isDetectionOfUnscheduledMeetingsEnabled}
      onChangeDetectionOfUnscheduledMeetings={onChangeDetectionOfUnscheduledMeetings}
      isRemindMeToJoinMeetingsAndTakeNotesEnabled={isRemindMeToJoinMeetingsAndTakeNotesEnabled}
      onChangeRemindMeToJoinMeetingsAndTakeNotes={onChangeRemindMeToJoinMeetingsAndTakeNotes}
    />
  );
};
